<p>Hier sind die Sicherheits- und Veranstaltungswachen aufgeführt. Hierzu bekommt ihr auch eine Erinnerungsemail (3 und 1 Tag vorher), wenn ihr für eine Wache eingeteilt seid. Bei Verhinderung bitte selbständig um Ersatz kümmern.</p>
